import React from 'react';
import { motion } from 'framer-motion';
import { Scale, ZapOff, Brain } from 'lucide-react';
export function PainBarSection() {
  const items = [{
    icon: <Scale className="w-12 h-12 text-brand-orange" data-id="element-77" />,
    text: 'Comés bien y entrenás... pero el peso no se mueve'
  }, {
    icon: <ZapOff className="w-12 h-12 text-brand-orange" data-id="element-78" />,
    text: 'Te sentís agotada aunque duermas 7 u 8 horas'
  }, {
    icon: <Brain className="w-12 h-12 text-brand-orange" data-id="element-79" />,
    text: 'Tenés antojos, niebla mental e irritabilidad sin explicación'
  }];
  return <section className="w-full bg-[#FDF6F0] py-8 md:py-14 px-4" data-id="element-80">
      <div className="max-w-6xl mx-auto" data-id="element-81">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-3xl font-bold text-center mb-6 md:mb-10 text-brand-text-primary" data-id="element-82">
          ¿Te identificás con alguna de estas situaciones?
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-6" data-id="element-83">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="flex flex-col items-center text-center p-4 md:p-6 rounded-2xl bg-white border border-[#E8D8E0] shadow-sm hover:shadow-md transition-all duration-300" data-id="element-84">
              <div className="mb-4 md:mb-6 p-4 bg-[#F3E8F0] rounded-full border border-[#D8C4E0]" data-id="element-85">
                {item.icon}
              </div>
              <p className="text-lg font-medium text-brand-text-body leading-relaxed" data-id="element-86">
                {item.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}